import { FC, useEffect, useState } from 'react';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import MenuIcon from '@mui/icons-material/Menu';
import DeleteIcon from '@mui/icons-material/Delete';
import Switch from '@mui/material/Switch';
import { Grid, Button, TextField } from '@mui/material';
import { SCUIContent } from '../../atomic/organisms';
import { SCUICustomDataGrid, SCUIMPAppHandlerDialog } from '../../atomic/molecules';
import { SCUIButton } from '../../atomic/atoms';
import Swal from 'sweetalert2';
import { MobilePanelAppQuery } from '../../services/query';
import MobileAppHandlerCommand from '../../services/command/mobileapphandler/MobileAppHandlerCommand.services';
import TimeHelper from '../../utils/time';
import { useTranslation } from 'react-i18next';

export const MpApplicationHandler: FC<any> = () => {
    const { t } = useTranslation();
    const [refresh, setRefresh] = useState(false);
    const [searchedMpHandlerName, setSearchedMpHandlerName] = useState('');
    const [searchedMpHandleList, setSearchedMpHandleList] = useState<any>();
    const refreshFunc = () => setRefresh((prevRefreshing) => !prevRefreshing);
    const [mobileAppHandler, setMobileAppHandler] = useState([]);
    const [open, setOpen] = useState(false);
    const [mpApplicationHandler, setMpApplicationHandler] = useState<any>();

    const getMobilePanelHandler = () => {
        MobilePanelAppQuery.ListMobilePanelApplication()
            .then((res: any) => {
                if (res) {
                    let parseData = res.model.data.map((item: any) => {
                        return {
                            id: item.id || '-',
                            name: item.name || '',
                            android_active: item.android_Active || false,
                            ios_active: item.ios_Active || false,
                            create_Date: TimeHelper.formatDateHour(item.create_Date) || '-',
                            update_Date: TimeHelper.formatDateHour(item.update_Date) || '-',
                            link: item.link || '',
                        };
                    });
                    setMobileAppHandler(parseData);
                    setSearchedMpHandleList(parseData);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            });
    };

    const handleClose = () => {
        setOpen(false);
    };
    const handleClickOpen = () => {
        setOpen(true);
    };
    useEffect(() => {
        getMobilePanelHandler();
    }, [refresh]);

    const sil = async (params: any) => {
        const result = await Swal.fire({
            text: t('mobileApp.deleteHandler'),
            cancelButtonText: t('general.cancel'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t('general.delete'),
        });

        if (!result.isConfirmed) {
            return;
        }

        try {
            await MobileAppHandlerCommand.PostRemoveMobileAppHandler(params);
            Swal.fire('Silindi!', ' ', 'success');
            setRefresh((prevRefreshing) => !prevRefreshing);
        } catch (error: any) {
            Swal.fire('', ' ', 'error');
            console.log('Hata :>> ', error);
        }
    };

    const columns: ExtendedGridColDef[] = [
        { field: 'id', headerName: 'ID', width: 90, flex: 1, hide: true },
        {
            field: 'name',
            headerName: t('mobileApp.name'),
            width: 150,

            flex: 1,
        },
        {
            field: 'link',
            headerName: 'Link',
            width: 150,

            flex: 1,
        },
        {
            field: 'android_Active',
            headerName: 'Android',
            width: 150,
            flex: 1,
            renderCell: (params) => {
                return (
                    <div>
                        <Switch checked={params.row.android_active} />
                    </div>
                );
            },
        },
        {
            field: 'ios_Active',
            headerName: 'IOS',
            width: 110,
            flex: 1,
            renderCell: (params) => {
                return (
                    <div>
                        <Switch checked={params.row.ios_active} />
                    </div>
                );
            },
        },
        {
            field: 'create_Date',
            headerName: t('mobileApp.createDate'),
            width: 160,
            type: 'date',
            flex: 1,
        },
        {
            field: 'update_Date',
            headerName: t('mobileApp.updateDate'),
            width: 160,
            type: 'date',
        },
        {
            field: 'düzenlee',
            headerName: t('general.edit'),
            width: 160,
            headerAlign: 'center',
            flex: 1,
            align: 'center',
            renderCell: (params) => {
                const onclick = () => {
                    setMpApplicationHandler(params.row);
                    handleClickOpen();
                };
                return (
                    <div>
                        <Button onClick={onclick}>
                            <MenuIcon />
                        </Button>
                    </div>
                );
            },
        },

        {
            field: 'sil',
            headerName: t('general.delete'),
            width: 160,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => {
                const onclick = () => {
                    sil(params.id);
                };
                return (
                    <div>
                        <Button onClick={onclick}>
                            <DeleteIcon />
                        </Button>
                    </div>
                );
            },
        },
    ];
    const requestSearchMpHandle = (searchedVal: any) => {
        setSearchedMpHandlerName(searchedVal.target.value);
        let filteredRoles = searchedMpHandleList.filter(
            (o: any) => o.name.toLowerCase().indexOf(searchedVal.target.value.toLowerCase()) !== -1
        );
        console.info(filteredRoles);
        setMobileAppHandler(filteredRoles);
    };

    return (
        <SCUIContent>
            <SCUIMPAppHandlerDialog
                selectedRow={mpApplicationHandler}
                open={open}
                onClose={handleClose}
                refresh={refreshFunc}
            />
            <Grid container direction="row">
                <Grid
                    size={{
                        lg: 10,
                        md: 12,
                        xs: 12,
                    }}
                >
                    <h1 className="headtxt">Application Handler </h1>
                </Grid>

                <Grid
                    size={{
                        lg: 2,
                        md: 6,
                        xs: 6,
                    }}
                >
                    <SCUIButton
                        text={t('mobileApp.addParameter')}
                        type="primary"
                        sizeType="fixed"
                        size={'m'}
                        onClick={() => {
                            setMpApplicationHandler([]);

                            handleClickOpen();
                        }}
                    />
                </Grid>
                <Grid
                    sx={{ marginBottom: 1, marginTop: 1, boxShadow: 0 }}
                    size={{
                        lg: 12,
                        md: 12,
                        xs: 12,
                    }}
                >
                    <TextField
                        label={t('mobileApp.name')}
                        value={searchedMpHandlerName}
                        onChange={(searchVal) => requestSearchMpHandle(searchVal)}
                        fullWidth
                    />
                </Grid>
                <Grid
                    size={{
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    }}
                >
                    <SCUICustomDataGrid
                        rows={mobileAppHandler}
                        columns={columns}
                        initialState={{
                            sorting: {
                                sortModel: [
                                    {
                                        field: 'id',
                                        sort: 'asc',
                                    },
                                ],
                            },
                        }}
                    />
                </Grid>
            </Grid>
        </SCUIContent>
    );
};
